import { render } from "./OverviewComponent.vue?vue&type=template&id=def22424&scoped=true"
import script from "./OverviewComponent.vue?vue&type=script&lang=js"
export * from "./OverviewComponent.vue?vue&type=script&lang=js"

import "./OverviewComponent.vue?vue&type=style&index=0&id=def22424&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def22424"]])

export default __exports__